/**
 * Copyright © 2021-2023 Delicious AI, LLC
 *
 * @author Kyle Armstrong <kyle.armstrong@deliciousai.com>
 */

import { useQuery } from '@apollo/client'
import { DAIGroupEnum, GET_GROUPS, GetGroupsQuery } from '@dai/graphql'

const DAI_GROUPS = [
  DAIGroupEnum.IMAGE_LABELERS,
  DAIGroupEnum.POINT_CLOUD_VERIFIERS,
  DAIGroupEnum.MAPPERS,
  DAIGroupEnum.MAPPER_ADMINS,
  DAIGroupEnum.STORE_MAP_SCANNERS,
]

export const useGetGroups = () => {
  const { data, ...rest } = useQuery<GetGroupsQuery>(GET_GROUPS, {
    notifyOnNetworkStatusChange: true,
  })
  const allGroups = data?.groups
  const groups = allGroups?.filter(
    group =>
      !DAI_GROUPS.some(
        g => group.name.toLowerCase() === g.toString().toLowerCase(),
      ),
  )

  const handleGetGroupByName = (name: string) =>
    allGroups?.find(g => g.name === name)

  return { allGroups, groups, handleGetGroupByName, ...rest }
}
